import i18n from '../i18n';

export const formatDate = (timestamp: any): string => {
  if (!timestamp) return '';

  let date: Date;
  try {
    if (
      timestamp &&
      typeof timestamp === 'object' &&
      timestamp.toDate &&
      typeof timestamp.toDate === 'function'
    ) {
      date = timestamp.toDate();
    } else if (timestamp instanceof Date) {
      date = timestamp;
    } else if (typeof timestamp === 'string' || typeof timestamp === 'number') {
      date = new Date(timestamp);
    } else if (
      timestamp &&
      typeof timestamp === 'object' &&
      timestamp.seconds
    ) {
      date = new Date(timestamp.seconds * 1000);
    } else if (
      timestamp &&
      typeof timestamp === 'object' &&
      timestamp._seconds
    ) {
      date = new Date(timestamp._seconds * 1000);
    } else {
      return '';
    }

    if (isNaN(date.getTime())) {
      return '';
    }
  } catch (error) {
    console.error('Error parsing date:', error, timestamp);
    return '';
  }

  const language = i18n.language || 'uk';

  if (language === 'uk') {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
  } else {
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    }).format(date);
  }
};

export const formatDateShort = (timestamp: any): string => {
  if (!timestamp) return '';

  let date: Date;
  try {
    if (
      timestamp &&
      typeof timestamp === 'object' &&
      timestamp.toDate &&
      typeof timestamp.toDate === 'function'
    ) {
      date = timestamp.toDate();
    } else if (timestamp instanceof Date) {
      date = timestamp;
    } else if (typeof timestamp === 'string' || typeof timestamp === 'number') {
      date = new Date(timestamp);
    } else if (
      timestamp &&
      typeof timestamp === 'object' &&
      timestamp.seconds
    ) {
      date = new Date(timestamp.seconds * 1000);
    } else if (
      timestamp &&
      typeof timestamp === 'object' &&
      timestamp._seconds
    ) {
      date = new Date(timestamp._seconds * 1000);
    } else {
      return '';
    }

    if (isNaN(date.getTime())) {
      return '';
    }
  } catch (error) {
    console.error('Error parsing date:', error, timestamp);
    return '';
  }

  const language = i18n.language || 'uk';

  if (language === 'uk') {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  } else {
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(date);
  }
};

export const formatDateTimeLocal = (timestamp: any): string => {
  if (!timestamp) return '';

  let date: Date;
  try {
    if (
      timestamp &&
      typeof timestamp === 'object' &&
      timestamp.toDate &&
      typeof timestamp.toDate === 'function'
    ) {
      date = timestamp.toDate();
    } else if (timestamp instanceof Date) {
      date = timestamp;
    } else if (typeof timestamp === 'string' || typeof timestamp === 'number') {
      date = new Date(timestamp);
    } else if (
      timestamp &&
      typeof timestamp === 'object' &&
      timestamp.seconds
    ) {
      date = new Date(timestamp.seconds * 1000);
    } else if (
      timestamp &&
      typeof timestamp === 'object' &&
      timestamp._seconds
    ) {
      date = new Date(timestamp._seconds * 1000);
    } else {
      return '';
    }

    if (isNaN(date.getTime())) {
      return '';
    }
  } catch (error) {
    console.error('Error parsing date:', error, timestamp);
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
